/**
 * Person silhouette placeholder (no upload icon inside)
 * Used in empty canvas state for "Upload Person"
 */
const PersonPlaceholder = ({ size = 200, className = '' }) => {
  const height = size * 1.2;
  const rawScale = size / 200;
  const scale = 0.3 + rawScale * 0.7;
  const personSize = Math.round(48 * scale);

  return (
    <div
      className={`placeholder-drop-zone ${className}`}
      style={{
        width: size,
        height: height,
        borderRadius: Math.max(12, Math.round(20 * rawScale)),
        border: '2px dashed #3bbaa8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        cursor: 'pointer',
        transition: 'background 0.2s',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none'
      }}
    >
      {/* Person bust icon */}
      <svg width={personSize} height={personSize} viewBox="0 0 48 48">
        <circle cx="24" cy="14" r="8" fill="none" stroke="#3bbaa8" strokeWidth="2" />
        <path d="M6 44 C6 32, 13 24, 24 24 C35 24, 42 32, 42 44" fill="none" stroke="#3bbaa8" strokeWidth="2" />
      </svg>
    </div>
  );
};

export default PersonPlaceholder;
